module.exports = (__webpack_require__(1))(5);


//////////////////
// WEBPACK FOOTER
// delegated ./src/events.js from dll-reference girder_plugin_jobs
// module id = 8
// module chunks = 0